<div class="c-form-field c-form-field--d c-form-field--img-uploader">
  <div class="c-form-field__body">
    <div class="c-form-field__placeholder" *ngIf="!value">
      <div class="mb-13">
        <img [src]="'assets/new-img/icons/' + iconName + '.svg'" [alt]="iconName" width="33px" height="30px" />
      </div>
      <div class="text-center mr-2">
        <p i18n="@@common.upload_file_hint">
          Upload your <b>{{ label }}</b> with Drag&Drop or
        </p>
        <p i18n="@@common.attach_file" class="text-color--primary">Attach file</p>
        <p class="text-color text-color--gray">
          JPG, PNG, SVG.
          <span i18n="@@common.size_limit_is">Size limit is {{ fileSizeLimit }} Mb</span>
        </p>
      </div>
      <input type="file" class="c-form-field__file-input" accept="image/png, image/jpeg, image/svg+xml" />
    </div>
    <div class="c-form-field__uploaded" *ngIf="value">
      <div class="c-form-field__preview">
        <img [src]="value" alt="" />
      </div>
      <div class="c-form-field__data">
        <div class="c-form-field__data-row" *ngIf="imageData.format">
          <span class="text-color text-color--gray mr-8">Format:</span>
          <span>{{ imageData.format | uppercase }}</span>
        </div>
        <div class="c-form-field__data-row" *ngIf="imageData.size">
          <span class="text-color text-color--gray mr-8">Size:</span>
          <span>{{ imageData.size }}</span>
        </div>
        <div class="c-form-field__data-row" *ngIf="imageData.resolution">
          <span class="text-color text-color--gray mr-8">Resolution:</span>
          <span>{{ imageData.resolution }}</span>
        </div>
        <button type="button" p500-ui-confluent-button color="warn" class="mt-6" i18n="@@common.delete_logo" (click)="removeImage()">
          Delete Logo
        </button>
      </div>
    </div>
  </div>
</div>
